import { tickerItems } from "@/mocks/home";

export default function NewsTicker() {
  return (
    <section className="w-full bg-accent-100/70 border-b border-accent-200/70">
      <div className="w-full px-4 md:px-8 py-3 flex items-center gap-4">
        <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 dark:text-foreground-950">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-pulse-line text-xs"></i>
          </span>
          实时速递
        </span>

        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            <div className="flex shrink-0">
              {tickerItems.map((t, i) => (
                <span
                  key={`a-${i}`}
                  className="mr-10 flex items-center gap-2 text-sm text-accent-950 whitespace-nowrap"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-600"></span>
                  {t}
                </span>
              ))}
            </div>
            <div className="flex shrink-0" aria-hidden="true">
              {tickerItems.map((t, i) => (
                <span
                  key={`b-${i}`}
                  className="mr-10 flex items-center gap-2 text-sm text-accent-950 whitespace-nowrap"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-600"></span>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}